module.exports = __webpack_public_path__ + "static/media/clean_general_new.34152d76.svg";